import React from 'react'
import PanelMemberTemplate from '../../components/PanelMemberTemplate'
import { Laura_data } from '../../assets'

const LauraGabrielaSARBU = () => {
  return (
    <>
    <PanelMemberTemplate {...Laura_data}/>
    </>
  )
}

export default LauraGabrielaSARBU
